module.exports = __webpack_public_path__ + "img/rinfo6.123eb81f.png";